import http from "@/utils/http";

export function getToken(data) {
  return http({
    url: "/upload/token?key=" + data,
    method: "get"
  });
}

export function getDownloadToken(data) {
  return http({
    url: "/download/url?url=" + data + "&expires=10",
    method: "get"
  });
}
